import configuredStore from '../../core/configureReduxStore';
import { setExpirationDate } from '../authorizedState/actions';
import {
  RESET,
  SET_SELECTED_FORM,
  SET_FORM_MESSAGE,
} from './actionTypes';

import ajaxClient from '../utils/ajaxClient';
import { HEADER_VALUE__CONTENT_TYPE } from '../utils/ajaxClient/constants';

import { saveAuthorizationJwtTokenInLocalStorage, saveAuthorizationRefreshTokenInLocalStorage } from '../helpers/localStorageHelper';
import { interceptErrorMessage } from '../shared/helpers/apiErrorsInterceptor';

export const reset = () => ({
  type: RESET,
});

export const setSelectedForm = (payload) => ({
  type: SET_SELECTED_FORM,
  payload,
});

export const setFormMessage = (payload) => ({
  type: SET_FORM_MESSAGE,
  payload,
});

export const logIn = (data, onSuccess, onFailure) => {
  return () => {
    const url = 'Authentication';

    return ajaxClient
      .postRequest(url, null, data, HEADER_VALUE__CONTENT_TYPE)
      .then((response) => {
        if (response.data.token && response.data.refreshToken) {
          saveAuthorizationJwtTokenInLocalStorage(response.data.token);
          saveAuthorizationRefreshTokenInLocalStorage(response.data.refreshToken);
        }
        if (onSuccess) {
          onSuccess(response.data);
        }
      })
      .catch((exception) => {
        if (onFailure) {
          onFailure((exception));
        }
      });
  };
};

export const logInWithExpiredPassword = (email, oldPassword, newPassword, onSuccess, onFailure) => {
  return () => {
    const url = 'Authentication/Expired';
    const data = { email, oldPassword, newPassword };

    return ajaxClient
      .postRequest(url, null, data, HEADER_VALUE__CONTENT_TYPE)
      .then((response) => {
        if (response.data.token && response.data.refreshToken) {
          saveAuthorizationJwtTokenInLocalStorage(response.data.token);
          saveAuthorizationRefreshTokenInLocalStorage(response.data.refreshToken);
          configuredStore.store.dispatch(setExpirationDate(response.data.refreshTokenExpireDate));
        }
        if (onSuccess) {
          onSuccess(response.data);
        }
      })
      .catch((exception) => {
        if (onFailure) {
          onFailure(interceptErrorMessage(exception));
        }
      });
  };
};

export const remindPassword = (email, onSuccess, onFailure) => {
  return () => {
    const url = 'Users/Password/Remind';

    return ajaxClient
      .postRequest(url, null, `"${email}"`, HEADER_VALUE__CONTENT_TYPE)
      .then((response) => {
        if (onSuccess) {
          onSuccess(response);
        }
      })
      .catch((exception) => {
        if (onFailure) {
          onFailure(interceptErrorMessage(exception));
        }
      });
  };
};

export const logOut = (onSuccess, onFailure) => {
  return () => {
    const url = 'Authentication';

    return ajaxClient
      .deleteRequest(url, null, null, HEADER_VALUE__CONTENT_TYPE)
      .then((response) => {
        if (onSuccess) {
          onSuccess(response);
        }
      })
      .catch((exception) => {
        if (onFailure) {
          onFailure(interceptErrorMessage(exception));
        }
      });
  };
};

export const signUp = (data, onSuccess, onFailure) => {
  const url = 'Users';

  return ajaxClient
    .postRequest(url, null, data, HEADER_VALUE__CONTENT_TYPE)
    .then((response) => { if (onSuccess) { onSuccess(response); } })
    .catch((exception) => {
      if (onFailure) {
        onFailure(interceptErrorMessage(exception));
      }
    });
};
